import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance/AxiosInstance";
import { useMessage } from "../MessageProvider/MessageProvider";

export default function Calculations({ setOpen, open }) {
  // let [open, setOpen] = useState(false);
  let [date, setDate] = useState({
    from: null,
    to: null,
  });
  let [loading, setLoading] = useState(false);
  let [data, setData] = useState(null);
  let navigate = useNavigate();
  const messageApi = useMessage();

  let getSolds = async () => {
    try {
      setLoading(true);

      let { data } = await axiosInstance.get(
        `/api/official/qoldiq?start_date=${date.from}&end_date=${date.to}`
      );
      if (data.success) {
        console.log("data");
        console.log(data);
        setData(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (date.from && date.to) {
      getSolds();
    }
  }, [date]);

  return (
    <Modal
      style={{ top: "10px" }}
      width="100vw"
      title="Kirim / Chiqim"
      open={open}
      //   loading={loading}
      onOk={() => {
        setOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setOpen(false);
      }}
      footer={[]}
    >
      <div className=" w-[100%] flex flex-row justify-center items-center m-auto gap-5">
        <div className="flex flex-col justify-start gap-1 max-w-[150px]">
          <label>Dan</label>
          <input
            type="date"
            onChange={(e) => {
              setDate({
                ...date,
                from: e.target.value,
              });
              console.log(e.target.value);
            }}
          />
        </div>
        <div className="flex flex-col justify-start gap-1 max-w-[150px]">
          <label>Gacha</label>
          <input
            type="date"
            onChange={(e) => {
              console.log(e.target.value);
              setDate({
                ...date,
                to: e.target.value,
              });
            }}
          />
        </div>
      </div>

      {data ? (
        <>
          {" "}
          {/* chiqim */}
          <div className="container mx-auto p-4">
            <h2 className="text-xl font-bold mb-4">Chiqim</h2>
            <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
              <thead>
                <tr className="bg-gray-100">
                  <th className="text-left px-4 py-2 border-b">Nomi</th>
                  <th className="text-left px-4 py-2 border-b">Tonna</th>
                </tr>
              </thead>
              <tbody>
                {data?.chiqim?.map((product, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } hover:bg-gray-100`}
                  >
                    <td className="px-4 py-2 border-b">{product?.name}</td>
                    <td className="px-4 py-2 border-b">
                      {product?.total_tonna}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* kirim */}
          <div className="container mx-auto p-4">
            <h2 className="text-xl font-bold mb-4">Kirim</h2>
            <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
              <thead>
                <tr className="bg-gray-100">
                  <th className="text-left px-4 py-2 border-b">Nomi</th>
                  <th className="text-left px-4 py-2 border-b">Tonna</th>
                </tr>
              </thead>
              <tbody>
                {data?.kirim?.map((product, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } hover:bg-gray-100`}
                  >
                    <td className="px-4 py-2 border-b">{product?.name}</td>
                    <td className="px-4 py-2 border-b">
                      {product?.total_tonna}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* qoldiq */}
          <div className="container mx-auto p-4">
            <h2 className="text-xl font-bold mb-4">Qoldiq</h2>
            <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
              <thead>
                <tr className="bg-gray-100">
                  <th className="text-left px-4 py-2 border-b">Nomi</th>
                  <th className="text-left px-4 py-2 border-b">Tonna</th>
                </tr>
              </thead>
              <tbody>
                {data?.qoldiq?.map((product, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } hover:bg-gray-100`}
                  >
                    <td className="px-4 py-2 border-b">{product?.name}</td>
                    <td className="px-4 py-2 border-b">
                      {product?.total_tonna}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </Modal>
  );
}
